import { render, staticRenderFns } from "./ExpansionTabs.vue?vue&type=template&id=32ad7a40&lang=pug&"
import script from "./ExpansionTabs.vue?vue&type=script&setup=true&lang=js&"
export * from "./ExpansionTabs.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ExpansionTabs.vue?vue&type=style&index=0&id=32ad7a40&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports